import Vue from 'vue'
import Antd from 'ant-design-vue';
import App from './App.vue'
import router from './router'
import store from './store'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'ant-design-vue/dist/antd.css';

Vue.config.productionTip = false

/* 在node_modules里面找到swiper文件夹里面的css文件 */
import 'swiper/css/swiper.css'

/* 使用Vue.use来注册一个轮播图插件 */
Vue.use(VueAwesomeSwiper)
Vue.use(Antd);
import less from 'less'
Vue.use(less)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
